const state = {
    itens: [],
    item: {
        name: '',
        is_active: false
    }
};

export default state;